import { render, staticRenderFns } from "./CompanyFounderEdit.vue?vue&type=template&id=b96e5dd6&"
import script from "./CompanyFounderEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyFounderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports